import {
  PROPERTY_CUSTOMER_ROLES,
  type PropertyCustomerRole,
} from "../../../../../_shared/_logic/enums"
import type { StatusDefinition } from "@kontextwerk/web-sdk/core/display/status"

export const propertyCustomerRoleLabels: Record<PropertyCustomerRole, string> = {
  OWNER: "Eigentümer",
  TENANT: "Mieter",
  MANAGER: "Verwaltung",
  BILLING_CONTACT: "Rechnungskontakt",
  OTHER: "Sonstige Rolle",
}

export const propertyCustomerRoleStatusColors: Record<
  PropertyCustomerRole,
  NonNullable<StatusDefinition["color"]>
> = {
  OWNER: "neutral",
  TENANT: "neutral",
  MANAGER: "neutral",
  BILLING_CONTACT: "neutral",
  OTHER: "neutral",
}

export const propertyCustomerRoleOptions = PROPERTY_CUSTOMER_ROLES.map((value) => ({
  value,
  name: propertyCustomerRoleLabels[value],
}))

export type PropertyCustomerOutreachValue = "true" | "false"

export const propertyCustomerOutreachOptions: Array<{
  value: PropertyCustomerOutreachValue
  name: string
}> = [
  { value: "true", name: "Ja" },
  { value: "false", name: "Nein" },
]

export const formatPropertyCustomerRole = (
  role: PropertyCustomerRole | string | null | undefined,
) => propertyCustomerRoleLabels[role as PropertyCustomerRole] ?? String(role || "Sonstige Rolle")

export const normalizePropertyCustomerRole = (
  role: PropertyCustomerRole | string | null | undefined,
): PropertyCustomerRole => {
  const candidate = String(role || "")
    .trim()
    .toUpperCase()

  return PROPERTY_CUSTOMER_ROLES.includes(candidate as PropertyCustomerRole)
    ? (candidate as PropertyCustomerRole)
    : "OTHER"
}

export const getPropertyCustomerRoleStatus = (
  role: PropertyCustomerRole | string | null | undefined,
): StatusDefinition<PropertyCustomerRole> => {
  const normalizedRole = normalizePropertyCustomerRole(role)

  return {
    value: normalizedRole,
    label: formatPropertyCustomerRole(normalizedRole),
    color: propertyCustomerRoleStatusColors[normalizedRole],
  }
}

export const defaultOutreachEnabledForRole = (
  role: PropertyCustomerRole | string | null | undefined,
) => normalizePropertyCustomerRole(role) !== "BILLING_CONTACT"

export const outreachEnabledToSelectValue = (
  value: boolean | null | undefined,
): PropertyCustomerOutreachValue => (value === false ? "false" : "true")

export const selectValueToOutreachEnabled = (
  value: PropertyCustomerOutreachValue | string | null | undefined,
) => String(value ?? "true") !== "false"
